import {callApi} from '../middleware/middlewares';

export const GetReportData = (data) => {
    return new Promise((resolve, reject) => {
        callApi('/get_reports', 'GET', data).then(res => {
            if(res.data.result === 'success'){
                resolve(res);
            }
            if(res.data.result === 'error'){
                reject(res.data.message);
            }
        })
    })
}

export const SendMessage = (data) => {
    return new Promise((resolve, reject) => {
        callApi('/send_msg_to_patient', 'GET', data).then(res => {
            if(res.data.result === 'success'){
                resolve(res);
            }
            if(res.data.result === 'error'){
                reject(res.data.message);
            }
        })
    })
}


// export default GetReportData;


// WEBPACK FOOTER //
// ./src/api/ReportsApi.jsx